import CreatableSelect from 'react-select/creatable';
import { CSSProperties } from 'react';
import { CreatableProps as ReactCreatableSelectProps } from 'react-select/creatable';

type OptionType = {
  label: string;
  value: string | number;
};

export interface StylishNewCreatableSelectProps
  extends ReactCreatableSelectProps<OptionType, boolean, any> {
  classes?: string;
  style?: CSSProperties;
  options: OptionType[];
  defaultValue?: OptionType | OptionType[];
  value?: OptionType | OptionType[];
  placeholder?: string;
  isClearable?: boolean;
  isSearchable?: boolean;
  isMulti?: boolean;
  isDisabled?: boolean;
  onCreateOption?: (inputValue: string) => void;

  [key: string]: any;
}

/** @deprecated Use ComboboxField with creatable for string options. */
export default function StylishNewCreatableSelect({
  classes,
  style,
  options,
  defaultValue,
  value,
  onChange,
  placeholder,
  isClearable,
  isSearchable,
  isMulti,
  isDisabled,
  onCreateOption,
  ...props
}: StylishNewCreatableSelectProps) {
  return (
    <div className={'form-selectbox ' + (classes ? classes : '')} style={style}>
      <CreatableSelect
        className="react-select-container"
        classNamePrefix="react-select"
        options={options}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        onCreateOption={onCreateOption}
        placeholder={placeholder}
        isClearable={isClearable}
        isSearchable={isSearchable}
        isMulti={isMulti || false}
        isDisabled={isDisabled}
        noOptionsMessage={() => 'No Items Found'}
        {...props}
      />
    </div>
  );
}
